<template>
  <bookings-summary />
</template>

<script>
import BookingsSummary from "@/components/3pl/Operations/Bookings/BookingsSummary";
export default {
  components: {
    BookingsSummary,
  },
};
</script>

<style></style>
